import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex-1 flex-col text-gary-text-sub-title-color mt-[20px] sm:mt-0 sm:ml-[50px]" }
const _hoisted_2 = { class: "hidden sm:block" }
const _hoisted_3 = { class: "sm:hidden px-2.5" }
const _hoisted_4 = { class: "hidden sm:block" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 新增地址 ")
const _hoisted_6 = { class: "flex flex-col sm:flex-row justify-between flex-wrap mx-[40px] sm:ml-5 sm:mr-0 gap-3 sm:gap-0" }
const _hoisted_7 = { class: "flex flex-col grow" }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { class: "text-[13px]" }
const _hoisted_10 = { class: "text-[13px] w-[80%] tracking-[.12em] text-light-gary-text-color" }
const _hoisted_11 = { class: "w-[80px] mt-3 sm:mt-1" }
const _hoisted_12 = { class: "mt-[12px] flex justify-center gap-2.5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_AddAddressModal = _resolveComponent("AddAddressModal")!
  const _component_ModalConfirm = _resolveComponent("ModalConfirm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Tabs, {
          data: [{ id: 1, text: '宅配-HORLaY物流' }],
          customClass: 'custom-order-tabs',
          onTabSelect: _ctx.tabSelect
        }, null, 8, ["onTabSelect"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Tabs, {
          data: [{ id: 1, text: '宅配-HORLaY物流' }],
          customClass: 'mobile-custom-order-tabs',
          onTabSelect: _ctx.tabSelect
        }, null, 8, ["onTabSelect"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Divider)
      ]),
      _createElementVNode("div", {
        class: "ml-[40px] sm:ml-6 my-[16px] sm:my-[30px] flex gap-2 text-gary-text-color tracking-[.06em] cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => {
        _ctx.showAddAddressModal = !_ctx.showAddAddressModal;
        _ctx.resetInfo();
      })
      }, [
        _createVNode(_component_Icon, {
          iconName: "add_black",
          width: '24px'
        }),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveryAddrList, (deliveryAddrItem) => {
          return (_openBlock(), _createElementBlock("div", {
            key: deliveryAddrItem.DeliveryAddrId,
            class: "flex basis-[47.7%] border-[1px] sm:mr-5 sm:mb-2.5 rounded py-2.5 px-4 sm:px-[16px] sm:py-[12px] justify-between"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(deliveryAddrItem.ReceiverName), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(deliveryAddrItem.ReceiverMobile), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(deliveryAddrItem.DeliveryCity +
              deliveryAddrItem.DeliveryDist +
              deliveryAddrItem.DeliveryAddr), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(["h-[30px] text-center text-xs leading-[30px] rounded-md text-white", [
              {
                'bg-primary-color': deliveryAddrItem.IsDefault === true,
                'bg-black-400-color': deliveryAddrItem.IsDefault === false,
              },
            ]])
              }, " 預設 ", 2),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Icon, {
                  onClick: ($event: any) => (_ctx.setEditDeliveryDetail(deliveryAddrItem)),
                  class: "cursor-pointer",
                  iconName: "circle_edit",
                  width: '20px'
                }, null, 8, ["onClick"]),
                _createVNode(_component_Icon, {
                  onClick: ($event: any) => (_ctx.remove(deliveryAddrItem)),
                  class: "cursor-pointer",
                  iconName: "circle_close",
                  width: '20px'
                }, null, 8, ["onClick"])
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_AddAddressModal, {
      info: _ctx.deliveryAddrItemInfo,
      "onUpdate:info": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deliveryAddrItemInfo) = $event)),
      isUpdate: _ctx.isUpdate,
      "onUpdate:isUpdate": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isUpdate) = $event)),
      show: _ctx.showAddAddressModal,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showAddAddressModal) = $event)),
      onOk: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAddAddressModal = false))
    }, null, 8, ["info", "isUpdate", "show"]),
    _createVNode(_component_ModalConfirm, { ref: "confirmModal" }, null, 512)
  ], 64))
}